import { ElIcon, ElInput, ElButton, ElForm, ElFormItem, ElCheckbox, ElDialog } from "element-plus";
import config from '../config';
import baseApp from './../innerAPP';
import App from './App';
const vm = baseApp(App, config.schoolId);
const components = [ElIcon, ElInput, ElButton, ElForm, ElFormItem, ElCheckbox, ElDialog];
const plugins = [];
components.forEach(component => {
    vm.use(component)
})
vm.mount('#app');
